// extracted by mini-css-extract-plugin
export default {"wrapper":"Arch_wrapper__7WJfx","left":"Arch_left__magDs","right":"Arch_right__lNfEq"};